// 🧿 طلسم محافظ فایل
import React from "react";
// UI Framework
import { toast } from "react-toastify";
import { TableCell, TableRow } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
// Common components
import {
  Button,
  DynamicDropdown,
  DynamicMultiSelectDropdown,
  Table,
} from "src/Components";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Requests
import {
  getBaseCluster,
  getBaseAssetByCluster,
  addActiveBaseAssets,
  getActiveClusterAndBaseAssets,
  deleteActiveCluster,
} from "src/Requests/iMEMarketWatch";
// Types
import type {
  IUnderlyingClusterSearchParams,
  IActiveAssets,
} from "src/Interfaces/iMEMarketWatch";

const Settings: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const [activeList, setActiveList] = React.useState<IActiveAssets[]>([]);
  const [searchParam, setSearchParam] = React.useState(
    {} as IUnderlyingClusterSearchParams
  );

  React.useEffect(() => {
    getActiveClusterAndBaseAssets().then((resp) => setActiveList(resp));
  }, []);

  const changeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const clickHandler = () => {
    setLoading(true);
    addActiveBaseAssets(searchParam?.ids)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setSearchParam({} as IUnderlyingClusterSearchParams);
          getActiveClusterAndBaseAssets().then((resp) => setActiveList(resp));
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex gap-5 items-end pl-6">
        <DynamicDropdown
          dropdown={{
            name: "clusterId",
            placeholder: "دسته نمادهای پایه",
          }}
          getData={getBaseCluster}
          onChange={changeHandler}
          value={searchParam?.clusterId}
        />

        <DynamicMultiSelectDropdown
          dropdown={{
            name: "ids",
            placeholder: "زیردسته‌ها",
            disabled: !searchParam?.clusterId,
          }}
          getData={() => getBaseAssetByCluster(searchParam?.clusterId)}
          onChange={changeHandler}
          inputId={searchParam?.clusterId}
          value={searchParam?.ids}
        />
        <div className="w-9">
          <Button
            text="ثبت"
            onClick={clickHandler}
            variant="contained"
            className="table-btn"
            loading={loading}
          />
        </div>
      </div>
      <div>
        <Table
          header={<div />}
          body={
            <>
              {activeList.map((item) => (
                <TableRow>
                  <TableCell>
                    <div className="text-sm">{item.clusterName}</div>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm">{item.baseAssetName}</div>
                  </TableCell>
                  <TableCell>
                    <div
                      className="hover:bg-red-100 transition-all rounded p-1"
                      onClick={() => {
                        deleteActiveCluster(item.baseAssetId).then(() =>
                          getActiveClusterAndBaseAssets().then((resp) =>
                            setActiveList(resp)
                          )
                        );
                      }}
                    >
                      <DeleteIcon
                        fontSize="small"
                        className={`cursor-pointer text-red-600 transition-all`}
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </>
          }
        />
      </div>
    </div>
  );
};

export default Settings;
